import { IcoCheck } from '@components/icons';
import { ComponentChildren } from 'preact';
import { CalUserMenu } from '../cal-user-menu';

const STEPS = ['interview', 'editpage', 'publish'] as const;
type Step = (typeof STEPS)[number];

type StepProps = {
  step: Step;
  activeStep: Step;
};

const StepConfig = {
  interview: { index: 0, title: 'Interview', description: 'Get to know you' },
  editpage: { index: 1, title: 'Edit Page', description: 'Make it yours' },
  publish: { index: 2, title: 'Publish', description: 'Go live' },
};

function Step({ step, activeStep }: StepProps) {
  const { title, description, index } = StepConfig[step];
  const isCurrent = step === activeStep;
  const isCompleted = index < StepConfig[activeStep].index;

  return (
    <>
      <div class={`flex items-center ${!isCompleted && !isCurrent ? 'opacity-70' : ''}`}>
        <div class="flex items-center gap-2">
          <div
            class={`
            flex items-center justify-center w-10 h-10 rounded-full text-sm font-medium shrink-0
            ${
              isCompleted
                ? 'bg-green-500 text-white'
                : isCurrent
                  ? 'bg-blue-500 text-white ring-4 ring-blue-100'
                  : 'bg-gray-200 text-gray-500'
            }
          `}
          >
            {isCompleted ? <IcoCheck class="size-5" /> : index + 1}
          </div>
          <div>
            <p
              class={`${isCompleted ? 'font-medium text-green-600' : isCurrent ? 'font-semibold text-blue-600' : 'font-medium text-gray-500'}
          `}
            >
              {title}
            </p>
            <p class="text-sm text-gray-500">{description}</p>
          </div>
        </div>
      </div>
      {index < STEPS.length - 1 && (
        <div class={`w-20 h-0.5 mx-3 ${isCompleted ? 'bg-green-500' : 'bg-gray-200'}`} />
      )}
    </>
  );
}

type StepsHeaderProps = {
  currentStep: Step;
  ctaButtons?: ComponentChildren;
  noBorder?: boolean;
  showAuthMenu?: boolean;
};

export function StepsHeader({
  showAuthMenu,
  currentStep,
  ctaButtons,
  noBorder = false,
}: StepsHeaderProps) {
  return (
    <div
      class={`flex flex-col gap-4 md:flex-row md:items-center justify-between px-6 py-4 bg-gray-100 border-gray-200 mb-2 ${noBorder ? '' : 'border-b shadow'}`}
    >
      <div class="hidden sm:flex items-center gap-8">
        <div class="flex items-center gap-3">
          {STEPS.map((step) => (
            <div key={step} class="flex items-center">
              <Step step={step} activeStep={currentStep} />
            </div>
          ))}
        </div>
      </div>
      <div class="flex items-center justify-between gap-2">
        {ctaButtons}{' '}
        <div class={`${showAuthMenu ? '' : 'hidden lg:block'}`}>
          <CalUserMenu />
        </div>
      </div>
    </div>
  );
}
